module.exports = __webpack_public_path__ + "static/fipcbiglove3-3517878a5c212f830b782a6c9416955a.jpeg";